import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { MessageBanner } from '@nhl/nhl-react-ui/lib/MessageBanner';

import { playersAndTeamsActionCreators } from '../../../redux/ducks/playersAndTeams';
import { dataTableActionCreators } from '../../../redux/ducks/playersAndTeams/dataTable';
import { commonMessages, reportSpecificMessages } from '../../../utility/commonMessages';
import { ExportStatsButton } from '../../components/buttons';
import Filters, { Breadcrumbs as FilterBreadcrumbs } from '../../components/filters';
import Legend from '../../components/legend';
import ReportOptions, { TimeFrameSelect } from '../../components/reportInputs';
import StatsTable from '../../components/statsTable';

import { DataAndFiltersContainer, ReportNameHeader, SubMenu } from './styles';

const Reports = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const playersAndTeamsReport = useSelector(({ playersAndTeams }) => playersAndTeams.report);
    const appliedReportState = playersAndTeamsReport.applied;
    const reportCategory = playersAndTeamsReport.reportCategory;

    const [timeFrame, setTimeFrame] = useState(appliedReportState.timeFrame);

    useEffect(() => {
        // When we navigate from a non report page (Glossary or Home page) the state hasn't been set to a report state
        // This will set the players and teams state based on the provided location.
        dispatch(playersAndTeamsActionCreators.resetPlayersAndTeamsState(location.pathname));
    }, [location.pathname]);

    useEffect(() => {
        dispatch(dataTableActionCreators.requestData());
    }, [location.pathname]);

    useEffect(() => {
        setTimeFrame(appliedReportState.timeFrame);
    }, [appliedReportState.timeFrame]);

    const generalReportName = commonMessages.fullReportName[appliedReportState.reportName];
    const reportSpecificName = reportSpecificMessages.fullReportName?.[reportCategory]?.[appliedReportState.reportName];
    const reportName = reportSpecificName || generalReportName;

    return (
        <div
            role="tabpanel"
            id={`${location.pathname.replace('/', '')}-tabpanel`}
            aria-labelledby={location.pathname.replace('/', '')}
        >
            <DataAndFiltersContainer>
                <SubMenu>
                    <TimeFrameSelect />
                </SubMenu>
                <div role="tabpanel" id={`${timeFrame}-tabpanel`} aria-labelledby={`${timeFrame}`}>
                    <ReportOptions />
                    <Filters />
                    <MessageBanner />
                    <ReportNameHeader aria-level={2}>
                        <FormattedMessage {...reportName} />
                        <FilterBreadcrumbs />
                        <ExportStatsButton />
                    </ReportNameHeader>
                    <StatsTable />
                    <Legend />
                </div>
            </DataAndFiltersContainer>
        </div>
    );
};

export { Reports as Component };
